import { useEffect, useState } from "react";
import { usePageTitle } from '../../hooks/usePageTitle';
import { Link } from 'react-router-dom'; // react-router **dom**
import SideBar from '../../components/global/SideBar';
import './index.css';
import ProgramCard from "../../components/programs/ProgramCard";
import type { UserProgram } from "../../types/userProgram.interface";
import { fetchUserPrograms } from "../../services/program.service";


export default function MyPrograms() {
  usePageTitle('Mis Programas - Holos');
  const [programs, setPrograms] = useState<UserProgram[]>([]);

  useEffect(() => {
    fetchUserPrograms().then(data => {
      if (data) {
        setPrograms(data);
      }
    }).catch(error => {
      console.error('Error fetching user programs:', error);
    });
  }, []);


  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-gray-200 py-15 px-6">
        <div className="bg-white p-6 rounded max-w-6xl mx-auto border border-gray-200 shadow-md">
          {programs.length === 0 ? (
            <div className="mx-auto max-w-xl py-3 text-center">
              <div className="text-lg font-semibold mt-4">
                Aún no te has inscrito en ningún programa o reto. Anímate a descubrir y{" "}
                <Link to="/programas" className="text-holos-dark underline">
                  ser guiado por expertos.
                </Link>
              </div>
              <div className="text-sm text-gray-600 my-3">
                ¿Quieres perder peso? ¿Obtener masa muscular? Accede a nuestros programas fitness
                especializados aptos para todos los niveles. Solo debes elegir el programa o reto,
                descargar tu calendario & guía nutricional.
              </div>
              <div className="text-center">
                <Link
                  to="/programas"
                  className="inline-block bg-holos-dark text-white px-4 py-2 rounded mt-2 mb-4 hover:bg-holos-dark/80"
                >
                  VER PROGRAMAS
                </Link>
              </div>
            </div>
          ) : (
            <>
              <h2 className="text-center text-4xl font-bold mb-4">Mis programas y retos</h2>
              <div className="text-center text-sm text-gray-600 mb-2">
                Estos son los programas y retos en los que estás actualmente inscrito. ¡Vamos por
                más! Para descubrir nuevos programas y retos,
              </div>
              <div className="text-center">
                <Link
                  to="/programas"
                  className="inline-block bg-holos-dark text-white px-4 py-2 rounded mb-2 hover:bg-holos-dark/80"
                >
                  VER MÁS PROGRAMAS Y RETOS
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-5">
                {programs.map(({ program, programCompleted }) => (
                  <ProgramCard
                    program={{
                      ...program,
                      ...(programCompleted
                        ? { programCompleted: true }
                        : { inProgress: true })
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
